import { render, staticRenderFns } from "./EditTemplateDialogue.vue?vue&type=template&id=7868b170&scoped=true&"
import script from "./EditTemplateDialogue.vue?vue&type=script&lang=js&"
export * from "./EditTemplateDialogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7868b170",
  null
  
)

export default component.exports